import {
  CheckSquareOutlined, LockOutlined, LogoutOutlined, SafetyCertificateOutlined, UserOutlined,
} from '@ant-design/icons';
import { Col, Row } from 'antd';
import CardLink from 'components/CardLink';
import Layout from 'components/Layout';
import withGuard from 'components/withGuard';
import { AdminContext } from 'constants/contexts';
import { PERMISSIONS } from 'constants/permissions';
import { useHasAnyOfPermissions } from 'hooks/useHasPermission';
import React, { useContext, useState } from 'react';
import { GmailIcon, OutlookIcon } from 'components/icons/EmailBrands';
import ProfileForm from './ProfileForm';

function AccountSettings() {
  const hasUserManagementPermission = useHasAnyOfPermissions([PERMISSIONS.USER_MANAGEMENT]);
  const hasBillingPermission = useHasAnyOfPermissions([PERMISSIONS.BILLING]);
  const { logoutUser } = useContext(AdminContext);

  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <Layout header={(
      <Layout.Header
        title="Account settings"
        description="All of your account’s utilities gathered here."
      />
    )}
    >
      <Row gutter={[16, 16]}>
        {hasBillingPermission && (
          <Col xs={24} sm={12} md={8}>
            <CardLink title="Subscription" icon={<CheckSquareOutlined />} link="/console/setting/subscription" />
          </Col>
        )}
        {hasUserManagementPermission && (
          <Col xs={24} sm={12} md={8}>
            <CardLink title="User Management" icon={<SafetyCertificateOutlined />} link="/console/user-management" />
          </Col>
        )}
        <Col xs={24} sm={12} md={8}>
          <CardLink title="Change Password" icon={<LockOutlined />} link="/forget-password" />
        </Col>
        <Col xs={24} sm={12} md={8}>
          <CardLink
            title="Profile"
            icon={<UserOutlined />}
            onClick={() => setDrawerOpen(true)}
          />
        </Col>
        <Col xs={24} sm={12} md={8}>
          <CardLink title="Connect Gmail" icon={<GmailIcon />} link="/console/setting/connect-gmail" />
        </Col>
        <Col xs={24} sm={12} md={8}>
          <CardLink title="Connect Outlook" icon={<OutlookIcon />} link="/console/setting/connect-outlook" />
        </Col>
        <Col xs={24} sm={12} md={8}>
          <CardLink
            title="Logout"
            icon={<LogoutOutlined />}
            onClick={() => {
              logoutUser();
            }}
          />
        </Col>
      </Row>
      <ProfileForm
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        title="Profile"
      />
    </Layout>
  );
}

export default withGuard(AccountSettings, null, { redirect: true });
